import React from "react";

const FileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="file_icon"
      data-name="file"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5845 7.15502C16.545 7.06458 16.4897 6.9819 16.4212 6.91085L11.4212 1.91085C11.3502 1.84234 11.2675 1.78703 11.177 1.74752C11.152 1.73585 11.1254 1.72919 11.0987 1.72002C11.029 1.69629 10.9564 1.682 10.8829 1.67752C10.8654 1.67585 10.8495 1.66669 10.832 1.66669H4.9987C4.07953 1.66669 3.33203 2.41419 3.33203 3.33335V16.6667C3.33203 17.5859 4.07953 18.3334 4.9987 18.3334H14.9987C15.9179 18.3334 16.6654 17.5859 16.6654 16.6667V7.50002C16.6654 7.48252 16.6562 7.46669 16.6545 7.44835C16.6505 7.37478 16.6362 7.30214 16.612 7.23252C16.6037 7.20585 16.5962 7.18002 16.5845 7.15502ZM13.8204 6.66669H11.6654V4.51169L13.8204 6.66669ZM4.9987 16.6667V3.33335H9.9987V7.50002C9.9987 7.72103 10.0865 7.933 10.2428 8.08928C10.3991 8.24556 10.611 8.33335 10.832 8.33335H14.9987L15.0004 16.6667H4.9987Z"
        fill={props.fill || "#6B7A94"}
      />
      <path
        d="M6.66797 10H13.3346V11.6667H6.66797V10ZM6.66797 13.3334H13.3346V15H6.66797V13.3334ZM6.66797 6.66669H8.33464V8.33335H6.66797V6.66669Z"
        fill={props.fill || "#6B7A94"}
      />
    </svg>
  );
};

export default FileIcon;
